import httpApi from '../api/httpApi';

const PRODUCT_PRICE_URL = '/api/v1/prices';

const useProductsPrice = (products) => {
    return httpApi.post<any>(PRODUCT_PRICE_URL, products).then((resp) => {
        return resp.getData();
    });
};

export default useProductsPrice;
